import React, { useState } from 'react'
import { Dropdown, Tooltip } from 'antd'
import { FiAlertTriangle } from 'react-icons/fi'
import { BsCheck2All } from 'react-icons/bs'
import { MdMoreVert, MdOutlineDoNotDisturbOn } from 'react-icons/md'
import Span from 'components/Span'
import { FaTruck } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { AiFillEye } from 'react-icons/ai'
import {
  REPORT_MAP,
  generateDeadlineByExpiration,
  pendingsDateLabel,
} from 'screens/Pendings/utils'
import useCloseDropdown from '../../../../hooks/useCloseDropdown'
import css from './index.scss'

const pendenciesIconsMap = {
  OPEN: <FiAlertTriangle />,
  RESOLVED: <BsCheck2All />,
  DISPOSED: <MdOutlineDoNotDisturbOn />,
}

const pendenciesClassNames = {
  OPEN: css.yellowTag,
  RESOLVED: css.greenTag,
  DISPOSED: css.grayTag,
}

const pendenciesStatus = {
  OPEN: 'Aberta',
  RESOLVED: 'Resolvida',
  DISPOSED: 'Descartada',
}

export const getDeadlineColor = (number) => {
  if (number >= 20) return css.green
  else if (number < 20 && number >= 5) return css.yellow
  return css.red
}

export const PendingTag = ({ pending, className = '' }) => {
  const isExpired =
    pending?.status === 'OPEN' && pending?.amountDaysToResolve <= 0
  return (
    <Tooltip
      title={
        pending && pending.status ? pendenciesStatus[pending.status] : 'n/a'
      }
    >
      <div
        className={[
          pending && pending.status
            ? pendenciesClassNames[pending.status]
            : css.tag,
          className,
          isExpired ? css.redTag : '',
        ].join(' ')}
      >
        {pending && pending.status && pendenciesIconsMap[pending.status]}
      </div>
    </Tooltip>
  )
}

const PendencieCard = ({
  pending,
  selectPendencie,
  disablePendency,
  markAsUnviewed,
}) => {
  const [visible, setVisible] = useCloseDropdown(false)

  const path =
    pending.shippingType === 'SINGLE'
      ? `/loads/${pending?.shippingHash}/details`
      : `/loads/${pending?.shippingHash}/details/delivery/${pending?.shippingDeliveryId}`

  const handleResolvePendency = (e) => {
    setVisible(false)
    selectPendencie(pending)
    e.stopPropagation()
  }

  const handleDisablePendency = () => {
    setVisible(false)
    disablePendency(pending)
  }

  const handleMarkAsUnviewed = () => {
    setVisible(false)
    markAsUnviewed(pending)
  }

  const menu = (
    <div className={css.dropdownWrapper}>
      <Link to={path} className={css.dropdownRow}>
        <FaTruck />
        <span>Visualizar Carga</span>
      </Link>
      {pending?.viewed && pending?.pendingType?.targetType !== 'SHIPPER' && (
        <div
          className={css.dropdownRow}
          onClick={handleMarkAsUnviewed}
          role="button"
          tabIndex={0}
          style={{
            borderBottom: 'none',
          }}
        >
          <AiFillEye />
          <span>Marcar como não visto</span>
        </div>
      )}
    </div>
  )

  return (
    <div className={css.wrapper}>
      <div
        className={css.container}
        onClick={handleResolvePendency}
        role="button"
        tabIndex={0}
      >
        <PendingTag pending={pending} />
        <div className={css.textWrapper}>
          <Span
            text={pending?.pendingType?.name || 'n/a'}
            className={css.title}
          />
          <Span text={pending?.externalId || 'n/a'} className={css.subtitle} />
        </div>
        <div className={css.divider} />
        <div className={css.textWrapper} style={{ width: '20%' }}>
          <Span text="Data de abertura" className={css.title} />
          <Span text={pending?.createdDate || 'n/a'} className={css.subtitle} />
        </div>
        <div className={css.divider} />
        <div className={css.textWrapper} style={{ width: '23%' }}>
          <Span
            text={pendingsDateLabel[pending?.status]}
            className={css.title}
          />
          {pending?.status === 'OPEN' ? (
            <Span
              text={generateDeadlineByExpiration(pending?.amountDaysToResolve)}
              styles={{ fontWeight: 500 }}
              className={[
                css.subtitle,
                getDeadlineColor(pending?.amountDaysToResolve),
              ].join(' ')}
            />
          ) : (
            <Span
              text={
                pending?.status === 'RESOLVED'
                  ? pending.resolvedDate
                  : pending.disposedDate
              }
              styles={{ fontWeight: 500 }}
              className={[css.subtitle].join(' ')}
            />
          )}
        </div>
        <div className={css.divider} />
        <div
          className={css.textWrapper}
          style={{ width: '20%', flexShrink: 0 }}
        >
          <Span text="Aberto por" className={css.title} />
          <Span
            text={
              pending?.createdBy
                ? REPORT_MAP[pending?.createdBy?.toUpperCase()] ||
                  pending?.createdBy
                : 'n/a'
            }
            className={css.subtitle}
          />
        </div>
        <div className={css.iconWrapper} onClick={(e) => e.stopPropagation()}>
          <Dropdown
            overlay={menu}
            placement="bottomRight"
            className={css.clicked}
            trigger={['click']}
            onVisibleChange={(v) => setVisible(v)}
            visible={visible}
          >
            <MdMoreVert
              className={css.icon}
              // onClick={(e) => e.stopPropagation()}
            />
          </Dropdown>
        </div>
      </div>
      {!pending?.viewed && pending?.pendingType.targetType === 'TRANSPORTER' && <div className={css.bullet} />}
    </div>
  )
}

export default PendencieCard
